import { fontClasses, FontProps, FONT_COLOR } from '../font-props';
import './font-heading2.scss';
import '../font.scss';

const FontHeading2: React.FC<FontProps> = (props): JSX.Element => {
    props = {
        ...props,
        color: typeof props.color === "undefined" ? FONT_COLOR.PRIMARY2 : props.color
    };

    return (
        <h2 className={`font font-heading2 ${fontClasses(props)}`}>{props.children}</h2>
    )
};

export default FontHeading2;
